import { render, staticRenderFns } from "./templateMgr.vue?vue&type=template&id=4fefbe3f&scoped=true"
import script from "./templateMgr.vue?vue&type=script&lang=js"
export * from "./templateMgr.vue?vue&type=script&lang=js"
import style0 from "./templateMgr.vue?vue&type=style&index=0&id=4fefbe3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefbe3f",
  null
  
)

export default component.exports